export default __webpack_public_path__ + "media/Seafood-Fish.63e991fb.png";